<template>
    <div class="union-of-aries_splash">

        <div class="splash_upcoming rsvp" v-if="activeRSVP">
            <img src="./assets/images/bg-wingtip-appiarius.jpg" />

            <div class="text-box">
                <router-link to="/" class="link-style">
                    &#8610; &nbsp;&nbsp;Main Page
                </router-link>

                <h6 class="margin-top-spacer">
                    RSVP
                </h6>

                <div class="rsvp-card" v-for="(name, index) in activeRSVP.name" v-bind:key="name.firstName">
                    <h5><b>+.*｡</b>
                        {{name.firstName}} {{name.surName}}
                    <b>*.+｡</b></h5>
                    <hr />
                    <span><i>Please let us know what you would like to be served for dinner, or if you are not attending:</i></span>	

                    <form class="radio-form" v-on:submit.prevent>
                        <div>
                            <div class="radio-form-option">
                            <input type="radio" :id="`american_${index}`" value="american" v-model="name.dinnerChoice">
                                <label :for="`american_${index}`" v-bind:class="{ selected: name.dinnerChoice == 'american' }">
                                    Attending - American dinner</label>
                            </div>

                            <div class="radio-form-option">
                            <input type="radio" :id="`latin_${index}`" value="latin" v-model="name.dinnerChoice">
                                <label :for="`latin_${index}`" v-bind:class="{ selected: name.dinnerChoice == 'latin' }">
                                    Attending - Latin American dinner</label>
                            </div>

                            <div class="radio-form-option">
                            <input type="radio" :id="`not-attending_${index}`" value="not-attending" v-model="name.dinnerChoice">
                                <label :for="`not-attending_${index}`" v-bind:class="{ selected: name.dinnerChoice == 'not-attending' }">
                                    Not attending</label>
                            </div>
                        </div>

                        <textarea placeholder="Enter special requests or allergen information here." v-model="name.dinnerNotes"></textarea>
                    </form>
                </div>
                
                <hr class="rsvp-divider" v-if="activeRSVP.hasRehearsal"/>

                <h6 class="margin-top-spacer" v-if="activeRSVP.hasRehearsal">
                    + Join us! +
                </h6>

                <div class="rsvp-card" v-if="activeRSVP.hasRehearsal">
                    <h5>
                        Rehearsal Dinner <br />
                        May 24th at 6:30pm </h5>
                    <hr />
                    <span><i>As an out of town guest or wedding participant, we'd love to have you join us in a pre-celebration for our rehearsal dinner! A buffet of food and drinks will be provided in a private room at Frida 602, a Mezcal bar in historic Covington, KY.</i></span>

                    <hr />

                    <form class="radio-form" v-on:submit.prevent>
                        <div>
                            <div class="radio-form-option">
                                <div v-for="(name, index) in activeRSVP.name" v-bind:key="name.firstName">
                                    <input type="checkbox" :id="`attending_${index}`" v-model="name.attendingRehearsal">
                                    <label :for="`attending_${index}`"
                                     v-bind:class="{ selected: name.attendingRehearsal === true }">
                                    {{name.firstName}} {{name.surName}} - 
                                    <template v-if="name.attendingRehearsal === true">Attending</template>
                                    <template v-else>Not Attending</template>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>

                    <hr/>

                    <a class="rsvp-text-link" href="https://www.google.com/maps/place/Frida+602/@39.0840264,-84.5172689,15z/data=!4m2!3m1!1s0x0:0x2e7184a4259cfdf7?sa=X&ved=0ahUKEwj8wJ-r2t_ZAhVtmK0KHR69AgQQ_BIIvgEwDw" target="_blank">
                        Frida 602<br />
                        602 Main St, Covington, KY 41011
                    </a>	

                    <a href="https://www.google.com/maps/place/Frida+602/@39.0840264,-84.5172689,15z/data=!4m2!3m1!1s0x0:0x2e7184a4259cfdf7?sa=X&ved=0ahUKEwj8wJ-r2t_ZAhVtmK0KHR69AgQQ_BIIvgEwDw" target="_blank">
                        <img src="./assets/images/frida.jpg" />
                    </a>
                </div>

                <button class="button-style" v-on:click="submitRSVP">submit</button>
            </div>

        </div>
        <div v-else class="loader">
            <div class="loadingGif"></div>
        </div>

        <div>
            <!-- <img src="./assets/images/ready.gif"> -->
        </div>

    </div>
</template>

<script>
import { db, rsvpsRef } from './firebase';
import { firestore } from 'firebase';
var debounce = require('lodash.debounce');

export default {
    name: 'reserve',
    props: ['docId'],
    data () {
        return {
            activeRSVP: null,
            toSaveRSVP: null,
            docUnsub: null,
        }
    },
    components: {
    },
    watch: {
        'docId' (docId) {
            this.activeRSVP = null;
            this.loadDoc();
        },
        'activeRSVP': {handler: function(newValue) {
                let holder = {};
                Object.assign(holder, newValue);
                holder.updatedAt = firestore.FieldValue.serverTimestamp();
                holder.updateKey = Math.random().toString(36).substring(7);
                this.savingRSVP = holder;
            },
            deep: true
        },
    },
    computed: {
        savingRSVP: {
            set: debounce(function(newValue) {
                let datum = this;
                // if (this.docUnsub) { this.docUnsub(); this.docUnsub = null; }
                if (datum.toSaveRSVP && newValue.updateKey == datum.toSaveRSVP.updateKey) {
                    return;
                }
                rsvpsRef.doc(this.docId).update(newValue)
                    .then(function() {
                        console.log("Document successfully updated!", newValue.updateKey);
                        // datum.loadDoc();
                    })
                    .catch(function(error) {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                    });
                datum.toSaveRSVP = newValue;
            }, 500),
            get: function(newValue) {
                return this.toSaveRSVP;
            }
        }
    },
    methods: {
        loadDoc: function() {
            let datum = this;
            if (datum.docUnsub) { return; }
            datum.docUnsub = rsvpsRef.doc(datum.docId).onSnapshot(function(doc) {
                if (doc.exists) {
                    let newData = doc.data();
                    delete newData['updatedAt'];
                    if (datum.toSaveRSVP && newData.updateKey == datum.toSaveRSVP.updateKey) {
                        return;
                    }
                    datum.activeRSVP = newData;
                } else {
                    datum.$router.push({ path: `/rsvp` });
                }
            });
        },
        submitRSVP: function() {
            let docId = this.docId;
            this.$router.push({ path: `/confirm/${docId}` });
        }
    },
    created: function() {
        this.loadDoc();
    },
    destroyed: function() {
        if (this.docUnsub) {
            this.docUnsub();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/Reserve.vue